import React, { Component } from 'react';
import { Card, Icon, Avatar, message, Input } from 'antd';
import { Redirect } from 'react-router-dom';
import PublicMenu from '../../components/TopMenu';
import FavButton from '../../components/FavButton';
import ServiceModal from '../../components/modals/ServiceModal';
import axios from 'axios';
import Configuration from '../../Configuration';
const { Meta } = Card;
const Search = Input.Search;

class Services extends Component {
  constructor() {
    super();
    this.headers = {Authorization: localStorage.getItem('visitapp:token')};
    this.schema = {name: ''};
    this.state = {redirect: false, services: [], filteredServices: [], modalVisible: false, current: this.schema, handleSave: this.handleCreate};
    this.validateToken = this.validateToken.bind(this);
    this.handleStatus = this.handleStatus.bind(this);
    this.getServices = this.getServices.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.handleCreate = this.handleCreate.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
  }

  componentDidMount() {
    this.validateToken();
    this.getServices();
  }

  validateToken() {
    if(!localStorage.getItem('visitapp:token'))
      this.setState({redirect: true});
    
    if(!Configuration.isInRol(localStorage.getItem('visitapp:rol'), "admin or manager"))
      this.setState({redirect: true});
  }

  getServices() {
    axios.get(`${Configuration.apiServer}/api/v1/services`, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida')
      
      this.setState({services: resp.data, filteredServices: resp.data});
    });
  }

  handleStatus(id) {
    axios.put(`${Configuration.apiServer}/api/v1/services/${id}/status`, {}, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida')

      message.success('Registro actualizado')
      this.getServices();
    });
  }

  handleSearch(event) {
    const services = this.state.services.filter(service => {
      return service.name.toLowerCase().indexOf(event.target.value.toLowerCase()) > -1
    });

    this.setState({filteredServices: services});
  }

  handleOpenModal(kind, record) {
    if(kind === 'new') {
      this.setState({modalVisible: true, current: this.schema, handleSave: this.handleCreate});
    } else {
      this.setState({modalVisible: true, current: record, handleSave: this.handleUpdate});
    }
  }

  handleCloseModal() {
    this.setState({modalVisible: false});
  }

  handleCreate(record) {
    axios.post(`${Configuration.apiServer}/api/v1/services`, {service: record}, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida')

      this.getServices();
      this.setState({modalVisible: false});
      message.success('Registro guardado');
    });
  }

  handleUpdate(record) {
    axios.put(`${Configuration.apiServer}/api/v1/services/${this.state.current.id}`, {service: record}, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida')

      this.getServices();
      this.setState({modalVisible: false});
      message.success('Registro actualizado');
    });
  }
  
  render() {
    // Verify authentication
    if(this.state.redirect) {
      return (
        <Redirect to="/" />
      );
    }

    // List of services
    const services = this.state.filteredServices.map(service => {
      return (
        <Card
          style={{ width: '24%', margin: '10px 0px' }}
          actions={[<a href={`/admin/services/${service.id}`}><Icon type="eye" /></a>, <Icon type="edit" onClick={() => { this.handleOpenModal('edit', service) }} />]}
          key={service.id}
        >
          <Meta
            avatar={<Avatar icon="tool" />}
            title={service.name}
            description={<span className={`cursor text-${Configuration.getStatus(service.status).color}`} onClick={() => { this.handleStatus(service.id) }}>{Configuration.getStatus(service.status).text}</span>}
          />
        </Card>
      );
    });

    // Render component
    return (
      <div>
        <PublicMenu />
        
        <div className="container" style={{ marginTop: '30px' }}>
          <div className="d-flex justify-content-between align-items-center">
            <h3 className="text-primary" style={{ marginBottom: '0px' }}>Servicios</h3>
            <Search placeholder="Buscar..." onChange={this.handleSearch} style={{ width: '30%' }} />
          </div>

          <br/>

          <div className="d-flex flex-row flex-wrap justify-content-between">
            {services}
          </div>
        </div>

        <FavButton handleClick={this.handleOpenModal} schema={this.state.current} />

        <ServiceModal visible={this.state.modalVisible} title={"Nuevo servicio"} current={this.state.current} handleClose={this.handleCloseModal} handleSave={this.state.handleSave} />
      </div>
    );
  }
}

export default Services;



// WEBPACK FOOTER //
// ./src/pages/admin/Services.js